import { initFederation } from '@angular-architects/native-federation';

const FEDERATION_MANIFEST_PATH = 'assets/federation.manifest.json';
const FEDERATION_INIT_TIMEOUT_MS = 10000;

const timeout = (ms: number) => {
  let timerId: ReturnType<typeof setTimeout>;
  const promise = new Promise<never>((_, reject) => {
    timerId = setTimeout(() => reject(new Error(`Federation init timed out after ${ms}ms`)), ms);
  });
  return { promise, clear: () => clearTimeout(timerId) };
};

const { promise: timeoutPromise, clear: clearFederationTimeout } = timeout(FEDERATION_INIT_TIMEOUT_MS);

Promise.race([
  initFederation(FEDERATION_MANIFEST_PATH),
  timeoutPromise
])
  .catch(() => {})
  .finally(() => clearFederationTimeout())
  .then(() => import('./bootstrap'))
  .catch(() => {});
